// methods here build URLs for site pages

export default {
    methods: {

        initializeDrawdownArray(warpThreadsCount, weftThreadsCount) {
            console.log('in draftEditorService initializeDrawdownArray, warpThreadsCount: ' + warpThreadsCount, 'weftThreadsCount: ' + weftThreadsCount)
            let drawdownArray = new Array(weftThreadsCount)
            for (let weftThreadNumber=0; weftThreadNumber < weftThreadsCount; weftThreadNumber++) {
                drawdownArray[weftThreadNumber] = new Array(warpThreadsCount)
            }
            return drawdownArray
        },

        getDisplayGridIndex(original, isReversed, totalSize) {
            return !isReversed ? original : totalSize - 1 - original
        },

        loadDrawdown(shaftsCount, treadlesCount, warpThreadsCount, weftThreadsCount, affectedWarpThreadNumbers, affectedWeftThreadNumbers, drawdownArray, treadlingArray, threadingArray, tieupArray) {
            // let today = new Date()
            // console.log('starting loadDrawdown at: ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())

            let weftThreadNumbersToProcess = affectedWeftThreadNumbers
            let warpThreadNumbersToProcess = affectedWarpThreadNumbers

            for (let weftThreadNumber of weftThreadNumbersToProcess) {
                let treadlingRow = this.getDisplayGridIndex(weftThreadNumber, true, weftThreadsCount)
                let treadlesForPick = new Array()
                for (let treadleNumber=0; treadleNumber < treadlesCount; treadleNumber++) {
                    let treadlingColumn = this.getDisplayGridIndex(treadleNumber, true, treadlesCount)
                    if (treadlingArray[treadlingRow][treadlingColumn]) {
                        treadlesForPick.push(treadleNumber)
                    }
                }

                let shaftsRaisedForPick = new Array()
                for (let treadleNumber of treadlesForPick) {
                    let tieupCol = this.getDisplayGridIndex(treadleNumber, true, treadlesCount)
                    for (let shaftNumber=0; shaftNumber < shaftsCount; shaftNumber++) {
                        let tieupRow = this.getDisplayGridIndex(shaftNumber, false, shaftsCount)
                        if (tieupArray[tieupRow][tieupCol]) {
                            shaftsRaisedForPick.push(shaftNumber)
                        }
                    }
                }

                for (let warpThreadNumber of warpThreadNumbersToProcess) {
                    let shaftsForWarpThread = new Array()
                    let threadingColumn = this.getDisplayGridIndex(warpThreadNumber, false, warpThreadsCount)
                    for (let shaftNumber=0; shaftNumber < shaftsCount; shaftNumber++) {
                        let threadingRow = this.getDisplayGridIndex(shaftNumber, false, shaftsCount)
                        if (threadingArray[threadingRow][threadingColumn]) {
                            shaftsForWarpThread.push(shaftNumber)
                        }
                    }
                    let shaftForWarpThread = shaftsForWarpThread[0]
                    let drawdownRow = treadlingRow
                    let drawdownCol = threadingColumn

                    // console.log('drawdownRow: ' + drawdownRow + ' drawdownCol: ' + drawdownCol)
                    // console.log('drawdown: ' + JSON.stringify(this.drawdown))
                    drawdownArray[drawdownRow][drawdownCol] = shaftsRaisedForPick.includes(shaftForWarpThread)
                }
            }
            // today = new Date()
            // console.log('finished loadDrawdown at: ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())
            // this.drawdownRenderingKey = this.uuidv4()
        },

        renderDrawdown(canvas, drawdownDataArray, weftThreadsArray, drawWarpThreads, clearCanvas, showReverseSide) {
            // console.log('in renderDrawdown')
            if (clearCanvas) {
                canvas.fillStyle = 'rgb(0, 0, 0)'
                canvas.fillRect(0, 0, this.canvasWidth, this.canvasHeight)
            }

            for (let rowIndex=0; ((rowIndex < this.rowsCount) && (rowIndex < weftThreadsArray.length)); rowIndex++) {
                let cellY = rowIndex * (this.cellPixelSize + this.borderThicknessPixels) + this.borderThicknessPixels
                for (let colIndex=0; ((colIndex < this.columnsCount) && (colIndex < this.warpThreads.length)); colIndex++) {
                    let cellX = colIndex * (this.cellPixelSize + this.borderThicknessPixels) + this.borderThicknessPixels
                    let warpThreadIsShowing = showReverseSide ? !drawdownDataArray[rowIndex][colIndex] : drawdownDataArray[rowIndex][colIndex]
                    let threadColor = warpThreadIsShowing ? this.warpThreads[colIndex] : weftThreadsArray[rowIndex]
                    let cellWidth = this.cellPixelSize
                    let cellHeight = this.cellPixelSize
                    let displayY = cellY
                    let displayX = cellX

                    if (this.showDividingLines) {
                        if (warpThreadIsShowing) {
                            if (rowIndex < this.rowsCount-1) {
                                let warpThreadIsShowingUnder = showReverseSide ? !drawdownDataArray[rowIndex+1][colIndex] : drawdownDataArray[rowIndex+1][colIndex]
                                if (warpThreadIsShowingUnder) {
                                    cellHeight += this.borderThicknessPixels
                                }
                            }
                        }
                        else {
                            if (colIndex < this.columnsCount-1) {
                                let weftThreadIsShowingRight = showReverseSide ? (drawdownDataArray[rowIndex][colIndex+1]) : !(drawdownDataArray[rowIndex][colIndex+1])
                                if (weftThreadIsShowingRight) {
                                    cellWidth += this.borderThicknessPixels
                                }
                            }
                        }
                    }
                    else {
                        displayX -= this.borderThicknessPixels
                        displayY -= this.borderThicknessPixels
                        cellWidth += (this.borderThicknessPixels * 2)
                        cellHeight += (this.borderThicknessPixels * 2)
                    }
                    if (threadColor) {
                        if (!warpThreadIsShowing || drawWarpThreads) {
                            canvas.fillStyle='rgb(' + threadColor.R + ',' + threadColor.G + ',' + threadColor.B + ')'
                            canvas.fillRect(displayX, displayY, cellWidth, cellHeight)
                        }
                    }
                    // if (rowIndex < 4 && colIndex < 4) {
                    //     console.log('rowIndex: ' + rowIndex + ', colIndex: ' + colIndex + ' threadColor: ' + JSON.stringify(threadColor))
                    // }
                }
            }
            // console.log('warpThreads: ' + JSON.stringify(this.warpThreads))
        },

        // returns numbers of first two adjacent columns which include tabby, or an empty array if none doe
        getOvershotTreadleNumbers(tieupArray, treadlingArray) {
            // first separate the treadling into four groups, every 4th treadle starting with 1, 2, 3, and 4
            // if the pattern is overshot, either groups 1 and 3 must be opposing tabby, or groups 2 and 4 must be opposing tabby with all the same treadles in each group
            // and the other groups must not contain any of the tabby treadles

            let group1 = []
            let group2 = []
            let group3 = []
            let group4 = []

            // console.log('treadlingArray: ' + JSON.stringify(treadlingArray))

            for (let pickNum=0; pickNum < treadlingArray.length; pickNum++) {
                let treadleNumber = this.firstDepressedTreadleNumber(pickNum, treadlingArray)
                if (pickNum % 4 === 0) {
                    group1.push(treadleNumber)
                }
                else if (pickNum % 4 === 1) {
                    group2.push(treadleNumber)
                }
                else if (pickNum % 4 === 2) {
                    group3.push(treadleNumber)
                }
                else if (pickNum % 4 === 3) {
                    group4.push(treadleNumber)
                }
            }
            /*
            console.log('treadlingArray: ' + JSON.stringify(treadlingArray))
            console.log('group1: ' + JSON.stringify(group1))
            console.log('group2: ' + JSON.stringify(group2))
            console.log('group3: ' + JSON.stringify(group3))
            console.log('group4: ' + JSON.stringify(group4))
            console.log('tieupArray: ' + JSON.stringify(tieupArray))
            */
            let tabbyTreadleNumbers = []

            if (this.allTreadlesSameInGroup(group1) && this.allTreadlesSameInGroup(group3) && !this.allTreadlesSameInGroup(group2) && !this.allTreadlesSameInGroup(group4)) {
                // tabby could be on group 1 or group 3
                let firstTreadleNum = group1[0]
                let secondTreadleNum = group3[0]

                // console.log('tabbyTreadNumbers1-3: ' + firstTreadleNum + ', ' + secondTreadleNum)

                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, false) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, true)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, true) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, false)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
            }
            else if (this.allTreadlesSameInGroup(group2) && this.allTreadlesSameInGroup(group4) && !this.allTreadlesSameInGroup(group1) && !this.allTreadlesSameInGroup(group3)) {
                // tabby could be on group 2 or group 4
                let firstTreadleNum = group2[0]
                let secondTreadleNum = group4[0]

                // console.log('tabbyTreadNumbers2-4: ' + firstTreadleNum + ', ' + secondTreadleNum)

                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, false) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, true)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
                if (this.everyOtherShaftRaised(tieupArray, firstTreadleNum, true) && this.everyOtherShaftRaised(tieupArray, secondTreadleNum, false)) {
                    tabbyTreadleNumbers.push(firstTreadleNum, secondTreadleNum)
                }
            }
            // console.log('tabby treadle numbers: ' + tabbyTreadleNumbers)
            return tabbyTreadleNumbers
        },

        everyOtherShaftRaised(tieupArray, columnNumber, evenNumbers) {
            // first try treadles 0 and 1
            let totalShafts = tieupArray.length
            let col = this.getDisplayGridIndex(columnNumber, false, tieupArray.length)
            let shaftNumber = evenNumbers ? 0 : 1
            for (shaftNumber; shaftNumber < tieupArray.length; shaftNumber+=2) {
                let row = this.getDisplayGridIndex(shaftNumber, true, totalShafts)
                if (!tieupArray[row][col]) {
                    return false
                }
            }
            return true
        },

        allTreadlesSameInGroup(treadleNumbersArray) {
            if (treadleNumbersArray.length < 2) {
                return false
            }
            for (let i=1; i<treadleNumbersArray.length; i++) {
                if (treadleNumbersArray[i] !== treadleNumbersArray[i-1]) {
                    return false
                }
            }
            return true
        },

        firstDepressedTreadleNumber(pickNumber, treadlingArray) {
            let rowNumber = this.getDisplayGridIndex(pickNumber, true, treadlingArray.length)
            let treadlesCount = treadlingArray[0].length
            for (let treadleNum = 0; treadleNum < treadlesCount; treadleNum++) {
                let colNumber = this.getDisplayGridIndex(treadleNum, false, treadlesCount)
                if (treadlingArray[rowNumber][colNumber]) {
                    return treadleNum
                }
            }
        },

        loadArraysFromDraftJSON(tieup, threading, treadling, warpThreads, weftThreads, sampleDraft) {
            this.loadTieupArrayFromDraftJSON(tieup, sampleDraft)
            this.loadThreadingArrayFromDraftJSON(threading, sampleDraft)
            this.loadTreadlingArrayFromDraftJSON(treadling, sampleDraft)
            this.loadWarpThreadsArrayFromDraftJSON(warpThreads, sampleDraft)
            this.loadWeftThreadsArrayFromDraftJSON(weftThreads, sampleDraft)
        },

        loadTieupArrayFromDraftJSON(tieup, sampleDraft) {
            tieup.fill(false)
            for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                tieup[shaft] = new Array(sampleDraft.TreadlesCount)
            }

            // console.log('entire tieup grid 1: ' + JSON.stringify(tieup))
            for (let treadle = 0; treadle < sampleDraft.TreadlesCount; treadle++) {
                let shaftsTiedToTreadle = sampleDraft.Tieup[treadle]
                let col = this.getDisplayGridIndex(treadle, false, sampleDraft.TreadlesCount)
                for (let shaft of shaftsTiedToTreadle) {
                    let row = this.getDisplayGridIndex(shaft, true, sampleDraft.ShaftsCount)
                    // console.log('tieup row: ' + row + ', col: ' + col)
                    tieup[row][col] = true
                }
            }
        },

        loadThreadingArrayFromDraftJSON(threading, sampleDraft) {
            threading.fill(false)
            for (let shaft = 0; shaft < sampleDraft.ShaftsCount; shaft++) {
                threading[shaft] = new Array(sampleDraft.WarpThreadsCount)
            }

            for (let warpThread=0; warpThread < sampleDraft.WarpThreadsCount; warpThread++) {
                let shaftsForWarpThread = sampleDraft.Threading[warpThread]
                let col = this.getDisplayGridIndex(warpThread, true, sampleDraft.WarpThreadsCount)
                for (let shaft of shaftsForWarpThread) {
                    let row = this.getDisplayGridIndex(shaft, true, sampleDraft.ShaftsCount)
                    threading[row][col] = true
                }
            }
        },

        loadTreadlingArrayFromDraftJSON(treadling, sampleDraft) {
            treadling.fill(false)
            for (let pick=0; pick < sampleDraft.WeftThreadsCount; pick++) {
                treadling[pick] = new Array(sampleDraft.TreadlesCount)
            }
            // console.log('entire treadling grid 1: ' + JSON.stringify(treadling))

            for (let pick = 0; pick < sampleDraft.WeftThreadsCount; pick++) {
                let treadleNumbers = sampleDraft.Treadling[pick]
                let row = this.getDisplayGridIndex(pick, false, sampleDraft.WeftThreadsCount)
                for (let treadle of treadleNumbers) {
                    let col = this.getDisplayGridIndex(treadle, false, sampleDraft.TreadlesCount)
                    treadling[row][col] = true
                }
            }
        },

        loadWarpThreadsArrayFromDraftJSON(warpThreads, sampleDraft) {
            for (let threadNumber=0; threadNumber < sampleDraft.WarpThreadsCount; threadNumber++) {
                let col = this.getDisplayGridIndex(threadNumber, true, sampleDraft.WarpThreadsCount)
                warpThreads[col] = JSON.parse(JSON.stringify(sampleDraft.WarpThreads[threadNumber])) // makes a deep copy of the color structure
            }
        },

        loadWeftThreadsArrayFromDraftJSON(weftThreads, sampleDraft) {
            for (let threadNumber=0; threadNumber < sampleDraft.WeftThreadsCount; threadNumber++) {
                let row = this.getDisplayGridIndex(threadNumber, false, sampleDraft.WeftThreadsCount)
                weftThreads[row] = JSON.parse(JSON.stringify(sampleDraft.WeftThreads[threadNumber])) // makes a deep copy of the color structure
            }
        },

        loadDraftJSONFromWarpThreadsArray(warpThreads, sampleDraft) {
            sampleDraft.WarpThreads = []
            for (let warpThreadNum=0; warpThreadNum < sampleDraft.WarpThreadsCount; warpThreadNum++) {
                let col = this.getDisplayGridIndex(warpThreadNum, true, sampleDraft.WarpThreadsCount)
                let warpThread = warpThreads[col]
                sampleDraft.WarpThreads.push(warpThread)
            }
        },

        loadDraftJSONFromWeftThreadsArray(weftThreads, sampleDraft) {
            sampleDraft.WeftThreads = []
            for (let weftThreadNum=0; weftThreadNum < sampleDraft.WeftThreadsCount; weftThreadNum++) {
                let row = this.getDisplayGridIndex(weftThreadNum, false, sampleDraft.WeftThreadsCount)
                let weftThread = weftThreads[row]
                sampleDraft.WeftThreads.push(weftThread)
            }
        },

        loadDraftJSONFromThreadingArray(threading, sampleDraft) {
            sampleDraft.Threading = []
            for (let warpThread=0; warpThread < sampleDraft.WarpThreadsCount; warpThread++) {
                let shaftsForThread = []
                let col = this.getDisplayGridIndex(warpThread, true, sampleDraft.WarpThreadsCount)
                for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                    let row = this.getDisplayGridIndex(shaft, true, sampleDraft.ShaftsCount)
                    if (threading[row][col]) {
                        shaftsForThread.push(shaft)
                    }
                }
                if (shaftsForThread.length > 0) { // skip warp threads that don't have any shaft assigned
                    sampleDraft.Threading.push(shaftsForThread)
                }
            }
        },

        loadDraftJSONFromTreadlingArray(treadling, sampleDraft) {
            sampleDraft.Treadling = []
            for (let pick=0; pick < sampleDraft.WeftThreadsCount; pick++) {
                let treadlesForPick = []
                sampleDraft.Treadling.push(treadlesForPick)
                let row = this.getDisplayGridIndex(pick, false, sampleDraft.WeftThreadsCount)
                for (let treadle=0; treadle < sampleDraft.TreadlesCount; treadle++) {
                    let col = this.getDisplayGridIndex(treadle, false, sampleDraft.TreadlesCount)
                    if (treadling[row][col]) {
                        treadlesForPick.push(treadle)
                    }
                }
            }
        },

        loadDraftJSONFromTieupArray(tieup, sampleDraft) {
            sampleDraft.Tieup = []
            for (let treadle=0; treadle < sampleDraft.TreadlesCount; treadle++) {
                let shaftsForTreadle = []
                sampleDraft.Tieup.push(shaftsForTreadle)
                let col = this.getDisplayGridIndex(treadle, false, sampleDraft.TreadlesCount)
                for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                    let row = this.getDisplayGridIndex(shaft, true, sampleDraft.ShaftsCount)
                    if (tieup[row][col]) {
                        shaftsForTreadle.push(shaft)
                    }
                }
            }
        },

        getDraftTableCellStyles(cellPixelSizeVal, includeRightPadding, includeBottomPadding) {
            let tdStyle = ''
            let pr ='0px'
            let pb='0px'
            if (includeRightPadding) {
                pr = cellPixelSizeVal + 'px'
            }
            if (includeBottomPadding) {
                pb = cellPixelSizeVal + 'px'
            }
            tdStyle = { paddingRight: pr, paddingBottom: pb }
            return tdStyle
        },

        getRemPixels() {
            let div = this.$refs['sizingDiv']
            div.style.height = '0.75rem'
            let remPixels = div.offsetHeight
            div.style.height = '0'
            return remPixels
        }

    }
}



// WEBPACK FOOTER //
// ./src/mixins/draftEditorService.js